import PDFViewer from "../../Components/Files/PDFViewer";

export function viewPDF(base64, prompt = false, handleClose, handleAccept) {
    return <PDFViewer base64={base64} close={handleClose} />
}